export default __webpack_public_path__ + "static/media/Youtube.85223493.svg";